import React, { Fragment } from 'react';
import { noop } from 'lodash';
import { Alert, Button } from 'reactstrap';
import Icon from 'jsx/components/core/icons/Icon';
import { HalfCircleSpinner } from 'react-epic-spinners';

const ReportsToolbar = ({
  isFilterButtonDisabled = false,
  hasFiltersChanged = false,
  isFilterOpen = false,
  displayFilterButton = true,
  selectedReportId = null,
  onFilterClick = noop,
  onExportClick = noop,
  isExportFetching = false,
  requestCount = 0
}) => (
  <>
    <Alert color="primary" className="d-flex justify-content-between p-0">
      <div className="d-flex m-2">
        <Button
          size="sm"
          color="primary"
          onClick={() => (isExportFetching ? null :onExportClick(selectedReportId))}
          disabled={(requestCount > 0)}
        >
          {isExportFetching && (
            <span className="d-flex justify-content-between">Exporting... <HalfCircleSpinner className="ml-2 align-self-center" color="white" size={20} /></span>
          )}
          {!isExportFetching && (
            <span>Export Report to PDF - BETA</span>
          )}
          
        </Button>
      </div>
      <div className="d-flex justify-content-end m-2">
        {hasFiltersChanged && (
          <Alert color="light" className="m-0 px-2 py-1 fs-14px border-0">
            * Apply new filter values
          </Alert>
        )}
        {displayFilterButton && (
          <Button
            size="sm"
            color="warning"
            className="text-white ml-2"
            onClick={onFilterClick}
            disabled={isFilterButtonDisabled}
          >
            Edit Filters
            <Icon name={isFilterOpen ? 'chevron-up' : 'chevron-down'} className="ml-1" />
          </Button>
        )}
      </div>
    </Alert>
  </>
);

export default ReportsToolbar;
